import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=02046a4a&scoped=true"
var script = {}
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=02046a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02046a4a",
  null
  
)

export default component.exports